// import {TimelineLite, TimelineMax } from "gsap";

import _ from './lodash.min';
import my from './conditions';
import variables from './variables';
import publicFunctions from './public-functions';
import conditions from './conditions';
import inhibitors from './inhibitors';
import treatments from './treatments';
import events from './events';

import $ from './jquery-3.2.1.min';

//This funtion is listening for any action in the page
events();

// GENERIC GEAR CLASS

function Gear(){
  this.myStatus = "";
  this.myName = "";
}
Gear.prototype.setStatus = function(status) {
  this.myStatus = this.myStatus + status;
};
Gear.prototype.runGear = function(status) {
  this.myStatus = status;
};

var factors = [
  variables.factor_12, variables.factor_11, variables.factor_09, variables.factor_07a, variables.factor_08, variables.factor_vW, variables.factor_05a,
  variables.factor_02a, variables.factor_01a, variables.factor_13a, variables.factor_CLOT, variables.grey_gear_01, variables.grey_gear_02, variables.grey_gear_03,
  variables.grey_gear_04, variables.grey_gear_05, variables.grey_gear_06, variables.grey_gear_07, variables.grey_gear_08, variables.grey_gear_09, 
  variables.small_gear_01, variables.small_gear_02, variables.small_gear_03, variables.small_gear_04];


_.forEach(factors, function(factor) {
  _.assign(factor, Gear);
});


(function(){
  document.querySelector("body div").classList.add("centered-div");
	publicFunctions.resetTreatmentFactors;
	return publicFunctions.runNormal();
})();




// WEBPACK FOOTER //
// ./src/js/main.js